import React from 'react';
import { defineMessages, injectIntl } from 'react-intl';

import UserVideo from './UserVideo';
import UserVideoDrawing from './UserVideoDrawing';
import UserVideoStatus from './UserVideoStatus';
import VideoError from '../../video/components/VideoError';

const messages = defineMessages({
  BEGIN_CALL_INSTRUCTION: {
    id: 'UserVideoContainer.BEGIN_CALL_INSTRUCTION',
    defaultMessage: 'Beginnen Sie den Call indem Sie auf "Gespräch anfangen" klicken.',
  },
  SEND_INVITE_INSTRUCTION: {
    id: 'UserVideoContainer.SEND_INVITE_INSTRUCTION',
    defaultMessage: 'Senden Sie die Einladung an Ihren Kunden entweder per SMS oder per E-Mail.',
  },
});

function UserVideoContainer(props) {
  const {
    activeCallCreatedAndRunning,
    call,
    closeUserVideo,
    connected,
    connection,
    handleStopCall,
    room,
    intl: { formatMessage },
  } = props;

  if (!call || !activeCallCreatedAndRunning) {
    return (
      <div className="video-status-container">
        <div className="video-status-message" style={{ textAlign: 'center', lineHeight: '1.6', color: '#94a3b8' }}>
          {formatMessage(messages.BEGIN_CALL_INSTRUCTION)}<br />
          {formatMessage(messages.SEND_INVITE_INSTRUCTION)}
        </div>
      </div>
    );
  }

  if (connection.subscribeError) {
    return (
      <div className="video-status-container">
        <div className="video-status-error">
          <VideoError error={connection.subscribeError} room={room} />
        </div>
      </div>
      );
  }

  if (!connected) {
    return (
      <UserVideoStatus
        activeCallCreatedAndRunning={activeCallCreatedAndRunning}
        handleStopCall={handleStopCall}
        {...props}
      />
    );
  } else if (false) {
    return (
      <UserVideoDrawing
        className={activeCallCreatedAndRunning && connected ? 'active' : ''}
        closeUserVideo={closeUserVideo}
        handleStopCall={handleStopCall}
        {...props}
      />);
  }

  return (
    <UserVideo
      className={activeCallCreatedAndRunning && connected ? 'active' : ''}
      closeUserVideo={closeUserVideo}
      handleStopCall={handleStopCall}
      {...props}
    />
  );
}

export default injectIntl(UserVideoContainer);
